/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {number}
 */

export const SwimProof = {
  YMCA: 1,
  RED_CROSS: 2,
  SCOUTS_BADGE: 3,
  LIFTGUARD_LETTER: 4,
} as const;

export type SwimProof = (typeof SwimProof)[keyof typeof SwimProof];

export type SwimProofEnumType = typeof SwimProof;
export type SwimProofOptional = SwimProof;
export type SwimProofTrackedI = SwimProof;
export type SwimProofTracked = SwimProof;
export type SwimProofMetaI = EnumMetaType<SwimProofEnumType, SwimProof>;
export const SwimProofMeta = typeMetaEnum<SwimProofEnumType, SwimProof>(
  "SwimProof",
  SwimProof,
);
export function transformDatesSwimProof(model: SwimProof) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
